import { DeepPartial, HistoryConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_HISTORY_CONFIG: DeepPartial<HistoryConfig> = {
  components: {
    toggle: null,
    clearItemIcon: 'TuandcoCloseIcon',
    clearAll: {
      icon: null
    }
  },
  queryHistorySize: 5
};
